

    var doc = JSON.parse("{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"FragmentDefinition\",\"name\":{\"kind\":\"Name\",\"value\":\"FollowerDetails\"},\"typeCondition\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"MemberProfile\"}},\"directives\":[],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"isFollowing\"},\"arguments\":[],\"directives\":[]},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"followerCount\"},\"arguments\":[],\"directives\":[]}]}}],\"loc\":{\"start\":0,\"end\":76}}");
    doc.__key = 0xee5c68efb2fb;
    doc.loc.source = { body: "ee5c68efb2fb" };
  


      export default doc;
    
